import React from "react";
import { MeasureRule } from "./MeetLat";

export function PageHeader({ title, subtitle, actions, size = "h2", rule = false, style }) {
  const kop = size === "display" ? "var(--text-display)" : size === "h1" ? "var(--text-h1)" : "var(--text-h2)";
  return (
    <div style={{ marginBottom: "var(--ruimte-8)", ...style }}>
      <div style={{ display: "flex", flexWrap: "wrap", alignItems: "flex-end", justifyContent: "space-between", gap: "var(--ruimte-6)" }}>
        <div>
          <h1 style={{ font: kop, letterSpacing: size === "display" ? "var(--ls-display)" : "var(--ls-kop)" }}>{title}</h1>
          {subtitle ? <p style={{ marginTop: "var(--ruimte-3)", fontSize: "var(--fs-body)", color: "var(--text-soft)" }}>{subtitle}</p> : null}
        </div>
        {actions ? <div style={{ display: "flex", flexWrap: "wrap", gap: "var(--ruimte-4)" }}>{actions}</div> : null}
      </div>
      {rule ? <MeasureRule height={10} spacing={7} style={{ marginTop: "var(--ruimte-6)" }} /> : null}
    </div>
  );
}
